// extracted by mini-css-extract-plugin
module.exports = {"root":"WidgetType1_root__2pvct","widgetHeader":"WidgetType1_widgetHeader__zw12D","widgetContent":"WidgetType1_widgetContent__36zmx"};